import { Component, input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import { CoreJssProxyModule } from '@core/jss-proxy';

@Component({
  selector: 'wl-generic-form-section',
  templateUrl: './generic-form-section.component.html',
  standalone: true,
  imports: [CoreJssProxyModule],
})
export class GenericFormSectionComponent {
  readonly rendering = input<InnogyComponentRendering>();
}
